<div class="loading" *ngIf="loading == true">Loading&#8230;</div>
<div class="urban-planner-profile">
    <div class="main-container">
        <mat-card class="table-card">
            <div class="card-header-section ms-20">
                <div class="left-content">
                    <h4 class="heading-4">My Profile</h4>
                </div>
                <div class="right-content">
                </div>
            </div>
            <div class="card-header-section ms-20" *ngIf="hasAdminRole">
                <div class="left-content">
                    <h4 class="heading-4">User Management</h4>
                </div>
                <div class="right-content">
                    <div class="d-flex buttonAddLeft">
                        <div class="ms-10"></div>
                        <button class="center-content add-button">
                            <mat-icon class="add-icon"></mat-icon>
                            <span class="paragraph">ACCOUNT VERIFIED
                                <br><ng-container>
                                    <mat-slide-toggle color="primary" [(ngModel)]="isAccountVerified"
                                        [ngClass]="{'disabled': isAccountVerifiedDisabled}"></mat-slide-toggle>
                                </ng-container>
                            </span>
                        </button>
                        <div class="ms-10"></div>
                        <button class="center-content add-button" (click)="endorseUrbanplanner()">
                            <mat-icon class="add-icon"></mat-icon>
                            <span class="paragraph">ENDORSEMENT<br>
                                <small *ngIf="currentUser?.endorsed == false">Pending</small>
                                <small *ngIf="currentUser?.endorsed == true">Endorsed</small></span>
                        </button>
                        <div class="ms-10"></div>
                        <button class="center-content add-button">
                            <mat-icon class="add-icon"></mat-icon>
                            <span class="paragraph">CONTRACT<br>
                                <ng-container>
                                    <mat-slide-toggle color="primary" [(ngModel)]="isContracted"
                                        [ngClass]="{'disabled': isContractedDisabled}"></mat-slide-toggle>
                                </ng-container></span>
                        </button>
                        <div class="ms-10"></div>
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <ng-container>
                                <button mat-menu-item>Menu 1</button>
                            </ng-container>
                        </mat-menu>
                        <div class="ms-10"></div>
                    </div>
                </div>
            </div>
            <div class="row paragraph ms-20" id="Personal Detail">
                <h4 class="heading-2">Personal Details</h4>
                <form class="profile-urban-planner-form" [formGroup]="profileUrbanPlannerForm"
                    id="profileUrbanPlannerFormId">
                    <div class="row paragraph ms-10">
                        <div class="col-3 mt-2">
                            <div class="form-group">
                                <img alt="profile-image" height="150" width="70%" [disabled]="viewOnly"
                                    src="../../../../../assets/images/placeholders/profile-picture-placeholder.jpg"
                                    class="border-section">
                            </div>
                        </div>
                        <div class="col-3 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">First Name</label>
                                <input class="col-12 mt-1" type="text" placeholder="John" [readOnly]="viewOnly"
                                    formControlName="firstName" />
                            </div>
                        </div>
                        <div class="col-3 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Surname</label>
                                <input class="col-12 mt-1" type="text" placeholder="Klaasons" [readOnly]="viewOnly"
                                    formControlName="surname" />
                            </div>
                        </div>
                        <div class="col-3 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Landline</label>
                                <input [readOnly]="viewOnly" class="col-12 mt-1" type="text" placeholder="John"
                                    formControlName="landline" />
                            </div>
                        </div>
                    </div>
                    <div class="row paragraph">
                        <div class="col-3 mt-2">

                        </div>
                        <div class="col-3 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Mobile</label>
                                <input class="col-12 mt-1" type="text" placeholder="012 222 3333" [readOnly]="viewOnly"
                                    formControlName="mobileNr" />
                            </div>
                        </div>
                        <div class="col-3 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Email</label>
                                <input class="col-12 mt-1" type="text" placeholder="test@m.com" [readOnly]="viewOnly"
                                    formControlName="email" />
                            </div>
                        </div>
                        <div class="col-3 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Identity/Passport number:</label>
                                <input class="col-12 mt-1" type="text" placeholder="John" [readOnly]="viewOnly"
                                    formControlName="identityNumber" />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row paragraph ms-20 mt-3" id="Planner Detail" *ngIf="urbanPlannerDtoList.length > 0">
                <h4 class="heading-2">Planner Details</h4>
                <form class="profile-urban-planner-form" [formGroup]="professionUrbanPlannerForm"
                    id="professionPlannerFormId">
                    <div class="row paragraph p">
                        <div class="col-4 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Graduated as a planner</label>
                                <input class="col-12 mt-1" type="text" placeholder="John"
                                    formControlName="graduatedAsPlanner" [readOnly]="viewOnly" />
                            </div>
                        </div>
                        <div class="col-4 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Institution</label>
                                <input class="col-12 mt-1" type="text" placeholder="Institution" [readOnly]="viewOnly"
                                    formControlName="institution" />
                            </div>
                        </div>
                        <div class="col-4 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Years of Experience</label>
                                <input class="col-12 mt-1" type="text" placeholder="John" [readOnly]="viewOnly"
                                    formControlName="yearsExperience" />
                            </div>
                        </div>
                    </div>
                    <div class="row paragraph">
                        <div class="col-4 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">SACPLAN registration type</label>
                                <mat-select class="col-12 mt-1" [(value)]="selectedSacplanRegistrationType"
                                    [compareWith]="compareSacPlanRegistrationTypes" [disabled]="true">
                                    <mat-option [value]="null">None</mat-option>
                                    <mat-option *ngFor="let type of sacplanRegistrationTypesList" [value]="type">
                                        {{type.value}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="col-4 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Full SACPLAN registration number</label>
                                <input [readOnly]="viewOnly" class="col-12 mt-1 placeholder-visible" type="text"
                                    placeholder="A4566/1988" formControlName="SACPLANNumber" />
                            </div>
                        </div>
                        <div class="col-4 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Metro</label>
                                <mat-select class="col-12 mt-1" [(value)]="selectedMetro" [compareWith]="compareMetro"
                                    [disabled]="true">
                                    <mat-option [value]="null">None</mat-option>
                                    <mat-option *ngFor="let metroItem of metroList" [value]="metroItem">
                                        {{metroItem.description}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row paragraph ms-20 mt-3" id="Agent Detail" *ngIf="estateAgentList.length > 0">
                <h4 class="heading-2">Agent Details</h4>
                <form class="profile-estate-agent-form" [formGroup]="estateAgentForm" id="estateAgentForm">
                    <div class="row paragraph p">
                        <div class="col-4 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Sectors</label>
                                <mat-select class="col-12 mt-1" [(value)]="selectedSector" [compareWith]="compareSector"
                                    multiple>
                                    <mat-option [value]="null">None</mat-option>
                                    <mat-option *ngFor="let sectorItem of sectorList" [value]="sectorItem">
                                        <mat-pseudo-checkbox class="mat-option-pseudo-checkbox"
                                            [state]="selectedSector?.includes(sectorItem) ? 'checked' : ''">
                                        </mat-pseudo-checkbox>
                                        {{sectorItem.value}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="col-4 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Status</label>
                                <mat-select class="col-12 mt-1" [(value)]="selectedStatus"
                                    [compareWith]="compareStatus">
                                    <mat-option [value]="null">None</mat-option>
                                    <mat-option *ngFor="let statusItem of estateAgentStatusesList" [value]="statusItem">
                                        {{statusItem.value}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="col-4 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Years of Operation</label>
                                <input class="col-12 mt-1" type="text" placeholder="John" [readOnly]="viewOnly"
                                    formControlName="yearsInOperation" />
                            </div>
                        </div>
                    </div>
                    <div class="row paragraph">
                        <div class="col-4 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Company Fidelity Fund Certificate Number</label>
                                <input class="col-12 mt-1" type="text"
                                    placeholder="companyFidelityFundCertificateNumber" [readOnly]="viewOnly"
                                    formControlName="companyFidelityFundCertificateNumber" />
                            </div>
                        </div>
                        <div class="col-4 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Individual Reference Number</label>
                                <input [readOnly]="viewOnly" class="col-12 mt-1" type="text"
                                    placeholder="individualReferenceNumber"
                                    formControlName="individualReferenceNumber" />
                            </div>
                        </div>
                        <div class="col-4 mt-2">
                            <div class="form-group">
                                <label class="col-12 bold">Metro</label>
                                <mat-select class="col-12 mt-1" [(value)]="selectedMetro" [compareWith]="compareMetro"
                                    [disabled]="true">
                                    <mat-option [value]="null">None</mat-option>
                                    <mat-option *ngFor="let metroItem of metroList" [value]="metroItem">
                                        {{metroItem.description}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="padding"></div>
        </mat-card>
    </div>
</div>